import { createContext } from 'react';

import { FancyRenderingContextType } from '.';

export const FancyRenderingContext = createContext<
  FancyRenderingContextType | undefined
>(undefined);
